import { useState, useEffect, useRef } from 'react';

export const useActiveTimer = (initialTimeSeconds = 0) => {
    const [timeInSeconds, setTimeInSeconds] = useState(initialTimeSeconds);
    const lastTickTime = useRef(Date.now());
    const isVisible = useRef(!document.hidden);

    useEffect(() => {
        // Handle visibility changes
        const handleVisibilityChange = () => {
            isVisible.current = !document.hidden;
            if (!document.hidden) {
                // We just became visible, reset the lastTickTime to avoid adding huge gaps
                lastTickTime.current = Date.now();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        const interval = setInterval(() => {
            if (isVisible.current) {
                const now = Date.now();
                const delta = Math.floor((now - lastTickTime.current) / 1000);
                if (delta >= 1) {
                    setTimeInSeconds((prev) => prev + delta);
                    lastTickTime.current = now;
                }
            } else {
                // Even if not visible, update last tick so when it becomes visible it doesn't add the gap
                lastTickTime.current = Date.now();
            }
        }, 1000);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            clearInterval(interval);
        };
    }, []);

    return { timeInSeconds, setTimeInSeconds };
};
